import { render, staticRenderFns } from "./EditFormTabStyle.vue?vue&type=template&id=219ee648&scoped=true&"
import script from "./EditFormTabStyle.vue?vue&type=script&lang=js&"
export * from "./EditFormTabStyle.vue?vue&type=script&lang=js&"
import style0 from "./EditFormTabStyle.vue?vue&type=style&index=0&id=219ee648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ee648",
  null
  
)

export default component.exports